import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface ICategory {
  [key: string]: any;
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface IDoccatalog {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface IDocToken {
  loading: boolean;
  result: string;
}
interface IDocUrl {
  loading: boolean;
  result: string;
}
interface IDocDownload {
  loading: boolean;
  result: string;
}
interface IDocInfo {
  loading: boolean;
  result: object;
}
interface IDocHomelist {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface IHotWords {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface IList {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}

export interface IState {
  [key: string]: any;
}

export const state: IState = {
  doccatalog: {
    loading: false,
    total: 0,
    infos: []
  } as IDoccatalog,
  docInfo: {
    loading: false,
    result: {}
  } as IDocInfo,
  category: {
    loading: false,
    infos: []
  } as ICategory,
  backgroundDoc: {
    loading: false,
    infos: []
  },
  backgroundIdDoc: {
    loading: false,
    infos: []
  },
  triggerMessage: {
    loading: false,
    infos: []
  },
  docToken: {
    loading: false,
    result: ''
  } as IDocToken,
  docUrl: {
    loading: false,
    result: ''
  } as IDocUrl,
  docDownload: {
    loading: false,
    result: ''
  } as IDocDownload,
  docHomelist: {
    loading: false,
    infos: []
  } as IDocHomelist,
  sysList: {
    loading: false,
    infos: []
  } as IDocHomelist,
  docClassList: {
    loading: false,
    infos: []
  } as IDocHomelist,
  hotWords: {
    loading: false,
    infos: []
  } as IHotWords
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
  docInfo: (myState: IState) => myState.docInfo,
  docDownload: (myState: IState) => myState.docDownload,
  docToken: (myState: IState) => myState.docToken,
  docUrl: (myState: IState) => myState.docUrl,
  doccatalog: (myState: IState) => myState.doccatalog,
  category: (myState: IState) => myState.category,
  backgroundDoc: (myState: IState) => myState.backgroundDoc,
  backgroundIdDoc: (myState: IState) => myState.backgroundIdDoc,
  triggerMessage: (myState: IState) => myState.triggerMessage,
  docHomelist: (myState: IState) => myState.docHomelist,
  docClassList: (myState: IState) => myState.docClassList,
  hotWords: (myState: IState) => myState.hotWords,
  sysList: (myState: IState) => myState.sysList
};
